import React, { Component } from 'react';
import styled from 'styled-components';
import AddDeviceComponent from './add.device';

const Container = styled.div`
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1060;
  background-color: rgba(0,0,10,0.5);
  backdrop-filter: blur(9px);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  p {
    margin: 20px 0 ;
  }
`;
const Span = styled.strong`
  color: orange;
`;


class ForceDeviceManageComponent extends Component {
  render() {
    return (
      <Container>
        <h5>به وب اپلیکیشن <Span>زیتونیکس</Span> خوش‌آمدید</h5>
        <p>برای شروع ابتدا یک دستگاه تعریف کنید</p>
        <AddDeviceComponent inForce />
      </Container>
    );
  }
}

export default ForceDeviceManageComponent;